import { H5, H2, H6 } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

export const OrderInfoCardPriceInfo = ({
  businessName,
  total,
  onBusinessNameClicked,
}: {
  businessName: string;
  total: number;
  onBusinessNameClicked?: () => void;
}): ReactElement => {
  return (
    <>
      <H5
        className={twMerge(
          "cursor-pointer hover:underline",
          onBusinessNameClicked ? "" : "pointer-events-none",
        )}
        onClick={onBusinessNameClicked}
      >
        {businessName}
      </H5>
      <H2>{formatCurrency(total)}</H2>
      <H6>Total (inc. VAT)</H6>
    </>
  );
};
